export class EmailDisplay {
	static init() {
		document.addEventListener("DOMContentLoaded", () => {
			const elements = document.getElementsByClassName(
				"email_no_bots_please"
			);
			for (let i = 0; i < elements.length; i++) {
				const element = elements[i];
				const email = "gui" + "@" + window.config.domain;
				element.innerHTML = email;
				if (element.tagName == "A") {
					element.setAttribute("href", `mailto:${email}`);
				}
			}
		});
	}
}
